import React, { useState } from 'react';
import { PayPalButtons } from '@paypal/react-paypal-js';
import { Box, Alert, CircularProgress, Typography } from '@mui/material';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';

// 标准PayPal按钮组件 - 使用Firebase Callable函数
const PayPalButtonStandard = ({ amount, currency = 'SGD', onSuccess, onError }) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  
  // 获取Firebase Functions实例
  const functions = getFunctions(getApp(), 'asia-southeast1');

  // 创建订单处理函数 - 使用PayPal SDK直接创建
  const createOrder = (data, actions) => {
    try {
      setLoading(true);
      setErrorMessage('');
      console.log('直接通过PayPal SDK创建订单，金额:', amount, '货币:', currency);

      // 使用PayPal SDK创建订单
      return actions.order.create({
        purchase_units: [
          {
            amount: {
              currency_code: currency,
              value: amount.toString(),
            },
          },
        ],
        application_context: {
          shipping_preference: 'NO_SHIPPING'
        }
      });
    } catch (error) {
      console.error('创建订单失败:', error);
      setErrorMessage(`创建订单失败: ${error.message}`);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  // 捕获订单处理函数 - 直接处理PayPal回调，不调用Firebase
  const onApprove = async (data, actions) => {
    try {
      setLoading(true);
      setErrorMessage('');
      console.log('用户批准支付，订单ID:', data.orderID);

      // 直接在PayPal客户端捕获订单
      console.log('直接使用PayPal客户端捕获订单');
      const captureResult = await actions.order.capture();
      console.log('支付捕获结果:', captureResult);

      // 创建模拟的支付结果
      const paymentResult = {
        id: data.orderID,
        status: 'COMPLETED',
        captureDetails: {
          status: 'COMPLETED',
          create_time: new Date().toISOString(),
          update_time: new Date().toISOString()
        },
        paymentSource: captureResult.payer || {}
      };

      console.log('支付完成，状态: COMPLETED');
      
      if (onSuccess) {
        onSuccess(paymentResult);
      }
    } catch (error) {
      console.error('捕获订单失败:', error);
      setErrorMessage(`处理支付失败: ${error.message}`);
      if (onError) {
        onError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  // 错误处理函数
  const handleError = (err) => {
    console.error('PayPal错误:', err);
    setErrorMessage(`PayPal错误: ${err.message || '未知错误'}`);
    if (onError) {
      onError(err);
    }
  };

  return (
    <Box sx={{ width: '100%', position: 'relative' }}>
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
          <CircularProgress size={24} />
        </Box>
      )}

      {errorMessage && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMessage}
        </Alert>
      )}

      <PayPalButtons
        style={{
          color: 'gold',
          layout: 'vertical',
          shape: 'rect',
          label: 'pay'
        }}
        createOrder={createOrder}
        onApprove={onApprove}
        onError={handleError}
        disabled={loading}
      />

      <Typography variant="caption" color="textSecondary" sx={{ display: 'block', textAlign: 'center', mt: 1 }}>
        通过PayPal安全支付，无需注册PayPal账户
      </Typography>
    </Box>
  );
};

export default PayPalButtonStandard;